import React, { forwardRef } from 'react';
import { Box, TextField, useTheme } from '@mui/material';

const RefCustomInput = forwardRef(({ label, placeholder, type, error, helperText, ...props }, ref) => {
    const theme = useTheme();

    return (
        <Box>
            <p
                style={{
                    color: theme.palette.text.primary,
                    fontSize: 13,
                    marginTop: 24,
                    marginBottom: 4,
                }}
            >
                {label}
            </p>
            <TextField
                placeholder={placeholder}
                type={type}
                variant="outlined"
                fullWidth
                error={error}
                helperText={helperText}
                inputRef={ref}
                InputProps={{
                    style: {
                        backgroundColor: theme.palette.customGrey.insideInput,
                        padding: '6px 8px',
                    },
                }}
                sx={{
                    position: 'initial',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: theme.palette.customGrey.borderInput,
                        },
                        '&:hover fieldset': {
                            borderColor: theme.palette.customGrey.borderInput,
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: theme.palette.primary.main,
                        },
                    },
                    '& .MuiInputBase-input': {
                        color: theme.palette.text.primary,
                        padding: '6px 8px',
                        '&::placeholder': {
                            fontSize: '14px',
                            color: theme.palette.text.secondary,
                            opacity: 1,
                        },
                    },
                }}
                {...props}
            />
        </Box>
    );
});


export default RefCustomInput;
